<div>
  <ng-template #moduleTypePopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelEditor()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{qmsservice.moduleName}}</label>
    </div><br>
    <div class="row px-4 py-2">
      <div class="d-flex row">
        <div class="col-md-12"><label id="deviationType-validation" for="email"
            [class.text-danger]="validationErrors.moduleType">
            {{parentData.moduleName}}
          </label><span class="mandatory-symbol">*</span>
          <mat-select matInput placeholder="Select" [(ngModel)]="moduleTypeValue" (closed)="dvTypesearchTxt=''"
            (click)="focusmethod('changeTypefocusSearch')" [class.is-invalid]="validationErrors.moduleType"
            (ngModelChange)="onModuleTypeChange()">
            <input type="search" id="changeTypefocusSearch" class="dropdownsearchstyle" [(ngModel)]="dvTypesearchTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of moduleTypeDropdown| assessmentSearch :dvTypesearchTxt"
              (onSelectionChange)="onmoduleTypeTypeSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>

        </div>
        <div class="col-md-6"
          *ngIf="(qmsservice.moduleName != 'AU' && qmsservice.activityDynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable != 'Y') || qmsservice.moduleName == 'AU'">
          <div><label for="email" id="expectedToBeStartedOn-validation"
              [class.text-danger]="validationErrors.expectedToBeStartedOn">
              <ng-container *ngIf="qmsservice.moduleName != 'AU'">
                Expected to be {{parentData.moduleStartedOnName}}
              </ng-container>
              <ng-container *ngIf="qmsservice.moduleName == 'AU'"> {{parentData.moduleStartedOnName}}</ng-container>
            </label><span class="mandatory-symbol" *ngIf="qmsservice.moduleName != 'AU'">*</span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="$present_future_config"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="expectedToBeStartedOn"
            (ngModelChange)="onExpectedToBeStartedOnChange()"
            [class.is-invalid]="validationErrors.expectedToBeStartedOn"
            [disabled]="qmsservice.moduleName == 'AU' && isStartedOnConfiguredInGroup">

        </div>
        <div class="col-md-6">
          <div><label for="email" id="expcetedClosureOn-validation"
              [class.text-danger]="validationErrors.expcetedClosureOn">
              <ng-container *ngIf="qmsservice.moduleName != 'AU'">
                Expected to be {{parentData.moduleclosedOnName}}
              </ng-container>
              <ng-container *ngIf="qmsservice.moduleName == 'AU'">
                {{parentData.moduleclosedOnName}}
              </ng-container>
            </label><span class="mandatory-symbol" *ngIf="qmsservice.moduleName != 'AU'">*</span>

          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="$expected_closure_dynamic_config()" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="expcetedClosureOn" (ngModelChange)="onExpectedClosureOnChange()"
            [class.is-invalid]="validationErrors.expcetedClosureOn"
            [disabled]="qmsservice.moduleName == 'AU' && isClosureOnConfiguredInGroup">
        </div>
        <div class="col-md-12">
          <div>
            <label for="email" id="justification">
              Justification
            </label> <span class="mandatory-symbol">*</span>
          </div>
          <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
            (ngModelChange)="onNgModelChange($event,'justification')" [(ngModel)]="justification"
            (input)="limitCharacters($event, 'JUSTIFICATION')"></textarea>
        </div>
      </div>
      <div class="pt-4 button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="saveEditor()">
          <i class="fas fa-check"></i> Save
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </ng-template>

</div>